import { render, staticRenderFns } from "./CostingTeaser.vue?vue&type=template&id=42bebe41&scoped=true&lang=pug&"
import script from "./CostingTeaser.vue?vue&type=script&lang=ts&"
export * from "./CostingTeaser.vue?vue&type=script&lang=ts&"
import style0 from "./CostingTeaser.vue?vue&type=style&index=0&id=42bebe41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bebe41",
  null
  
)

export default component.exports